module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"":"Czech","english":"English","hungarian":"Hungarian","polish":"Polish","slovakian":"Slovak","ukranian":"Ukranian"}}')
  delete Component.options._Ctor
}
